<div [ngStyle]="{ display: widgetTreeService.editMode() ? 'none' : 'block' }">
  <router-outlet></router-outlet>
</div>
@if (widgetTreeService.editMode()) {
  <div style="padding: 50px" class="flex flex-col justify-center items-center">Hier werden Unterseiten angezeigt.</div>
}
